<div class="grid grid-cols-12 gap-2">
  <mat-form-field appearance="outline" class="col-span-12" floatLabel="always">
    <mat-label>Test Room Name {{ required ? "*" : "" }}</mat-label>
    <input
      matInput
      type="text"
      placeholder="Search test room"
      [disabled]="disabled"
      [(ngModel)]="selectedRoom"
      (ngModelChange)="filterRooms($event)"
      [matAutocomplete]="auto"
    />
    <mat-icon matSuffix>search</mat-icon>

    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayRoom"
      (optionSelected)="onSelectTestRoom($event.option.value)"
    >
      <mat-option
        *ngFor="let Room of filteredRooms"
        [value]="Room"
      >
        {{ Room.viewValue }}
      </mat-option>
      <mat-option *ngIf="ability.canCreate(ability.subjects.TestRoom)" (click)="openAddTestRoomDialog()" class="text-blue-500"
        >+ Add new room</mat-option
      >
    </mat-autocomplete>
  </mat-form-field>


</div>
